module.exports = __webpack_public_path__ + "img/cpbox-offline.b5187473.png";